import React, { useEffect, useRef } from "react";
import { Toast } from "bootstrap";
import TaskAltSharpIcon from '@mui/icons-material/TaskAltSharp';
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import { useTranslation } from "react-i18next";
import { Portal } from "../components/Portal";

const SuccessToast = ({ show, message, onClose }) => {
  const toastRef = useRef(null);
  const { t } = useTranslation();

  useEffect(() => {
    if (show && toastRef.current) {
      const toastElement = toastRef.current;
      const bootstrapToast = new Toast(toastElement, {
        autohide: true,
        delay: 3000,
      });
      bootstrapToast.show();
      toastElement.addEventListener("hidden.bs.toast", onClose);
      return () => {
        toastElement.removeEventListener("hidden.bs.toast", onClose);
      };
    }
  }, [show, message, onClose]);

  if (!show) return null;

  return (
    <Portal layer="toast">
    <div className="wlj-app-toast position-fixed bottom-0 end-0 p-3" style={{ zIndex: 30000 }}>
      <div
        className="toast fade no-border-radius"
        ref={toastRef}
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
      >
        <div className="toast-header text-white success-toast">
          <TaskAltSharpIcon className="material-symbols-sharp me-2" />
          <strong className="me-auto">{t("modals.Success")}</strong>
          <CloseSharpIcon
            style={{ fontSize: "18px", fontWeight: "600", color: "black" }}
            className="pointer"
            onClick={() => {
              const bootstrapToast = Toast.getInstance(toastRef.current);
              if (bootstrapToast) {
                bootstrapToast.hide();
              }
              onClose();
            }}
          />
        </div>
        <div className="toast-body text-white" style={{ textAlign: "start" }}>
          {message}
        </div>
      </div>
    </div>
    </Portal>
  );
};

export default SuccessToast;
